import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import DateInput from "../../input/DateInput";
import SelectDropdown from "../../input/SelectDropdown";
import { MannerOfDeath } from "../../enums/MannerOfDeath";

const Death = () => {
    return (
        <QuestionPanel headerText="Please provide details about the death."
                       detailsText="The date of death should be the same date from the death certificate."
                       panelContent={
                           <>
                               <DateInput id="date-of-death" label="Date of death" required={false}/>
                               <SelectDropdown id="manner-of-death" label="Manner of death" required={true} options={
                                   Object.keys(MannerOfDeath).map(mannerOfDeath => ({
                                       id: mannerOfDeath.replace(/_/g, '-').toLowerCase(),
                                       text: (MannerOfDeath as any)[mannerOfDeath]
                                   }))}/>
                           </>
                       }>
        </QuestionPanel>
    )
};
export default Death;